/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPayorFormFieldOptionsInner
 */
export interface HchbPayorFormFieldOptionsInner {
    /**
     * 
     */
    value: string;
    /**
     * 
     */
    label: string;
}

/**
 * Check if a given object implements the HchbPayorFormFieldOptionsInner interface.
 */
export function instanceOfHchbPayorFormFieldOptionsInner(value: object): value is HchbPayorFormFieldOptionsInner {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function HchbPayorFormFieldOptionsInnerFromJSON(json: any): HchbPayorFormFieldOptionsInner {
    return HchbPayorFormFieldOptionsInnerFromJSONTyped(json, false);
}

export function HchbPayorFormFieldOptionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorFormFieldOptionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
    };
}

export function HchbPayorFormFieldOptionsInnerToJSON(json: any): HchbPayorFormFieldOptionsInner {
    return HchbPayorFormFieldOptionsInnerToJSONTyped(json, false);
}

export function HchbPayorFormFieldOptionsInnerToJSONTyped(value?: HchbPayorFormFieldOptionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

